export default {
  // no colors in the TH palette will fulfill a11y contrast requirements
  unselectedColor: Styles.color.black,
  activeBorderColor: Styles.color.primary,
  activeColor: Styles.color.primary,
};
